import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Grid, Text } from 'elements';
import { RootState } from 'modules';
import moment from 'moment';
import { sampleCaseNoteHitCount, IntroductionPageHitCount } from 'libs/api/case';
import { CWindowWidth, CHowToBuyCaseNote } from 'constants/base.const';
import { Button, Modal } from 'antd';
import { Colors, PrimaryColor } from 'GlobalStyles';
import CheckIcon from 'assets/icons/check.svg';
import MainBackImage from 'assets/images/banners/4.webp';
import IntroductionImage1 from 'assets/images/pages/introduce/introduction_1.webp';
import IntroductionImage2 from 'assets/images/pages/introduce/introduction_2.webp';
import IntroductionImage3 from 'assets/images/pages/introduce/introduction_3.webp';

const Introduction = () => {
  const history = useHistory();

  //샘플 노트 조회수 카운트
  const hitCount = async () => {
    const { success, data } = await sampleCaseNoteHitCount();
  };

  //소개 페이지 조회수 카운트;
  useEffect(() => {
    const pageHitCount = async () => {
      const { success, data } = await IntroductionPageHitCount();
    };
    pageHitCount();
  }, []);

  return (
    <>
      <Helmet>
        <title>케이스 노트 소개</title>
      </Helmet>
      <Grid image={MainBackImage} height='400px' md={{ height: '100px' }}>
        <Grid height='100%' backgroundColor={`${Colors.black}33`} justify='center'>
          <Grid width={`${CWindowWidth}px`} padding='0 7%' align='center'>
            <Grid>
              <Text color={Colors.white} size='4rem' bold md={{ size: '2rem' }}>
                케이스 노트 소개
              </Text>
            </Grid>
            <Grid marginTop='5px'>
              <Text color={Colors.white} size='1.1rem' md={{ size: '0.9rem' }}>
                어디에서도 볼 수 없었던, Career Step 만의 Case 를 소개합니다.
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid justify='center' marginTop={'80px'} md={{ marginTop: '40px' }}>
        <Grid width={`${CWindowWidth}px`} padding='0 5%'>
          <Text size='2rem' bold>
            컨텐츠 구성
          </Text>
        </Grid>
      </Grid>

      <Grid justify='center' marginTop={'50px'} md={{ marginTop: '20px' }}>
        <Grid
          width={`${CWindowWidth}px`}
          padding='0 5%'
          gap='20px'
          isNoWrap
          md={{ padding: '0 7%', isNoWrap: false }}
        >
          <Grid width='50%' md={{ width: '100%' }}>
            <Grid image={IntroductionImage1} height='240px' md={{ height: '140px' }} />
          </Grid>
          <Grid width='50%' md={{ width: '100%' }} align='center'>
            <Grid md={{ justify: 'center' }}>
              <Text size='1.7rem' bold md={{ size: '1.1rem' }}>
                MBB 최신 기출 기반 “트렌디한 Case”
              </Text>
            </Grid>
            <Grid gap='5px' align='center' marginTop='8px' isNoWrap>
              <Grid image={CheckIcon} width='20px' height='20px' />
              <Text size='1.1rem' bold md={{ size: '0.9rem' }}>
                자율주행차, 디지털 금융 등 최근 업계에서 가장 핫한 토픽과 산업 반영
              </Text>
            </Grid>
            <Grid gap='5px' align='center' marginTop='4px' isNoWrap>
              <Grid image={CheckIcon} width='20px' height='20px' />
              <Text size='1.1rem' bold md={{ size: '0.9rem' }}>
                실제 MBB Case 인터뷰와 매우 흡사한 문제 구성 및 진행 방식
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid justify='center' marginTop={'50px'} md={{ marginTop: '20px' }}>
        <Grid
          width={`${CWindowWidth}px`}
          padding='0 5%'
          gap='20px'
          isNoWrap
          md={{ padding: '0 7%', isNoWrap: false }}
        >
          <Grid width='0%' md={{ width: '100%' }}>
            <Grid image={IntroductionImage2} height='240px' md={{ height: '140px' }} />
          </Grid>
          <Grid width='50%' md={{ width: '100%' }} align='center'>
            <Grid md={{ justify: 'center' }}>
              <Text size='1.7rem' bold md={{ size: '1.1rem' }}>
                “10명 이상의 멘토가” 직접 풀이한 해설
              </Text>
            </Grid>
            <Grid gap='5px' align='center' marginTop='8px' isNoWrap>
              <Grid image={CheckIcon} width='20px' height='20px' />
              <Text size='1.1rem' bold md={{ size: '0.9rem' }}>
                MBB 전/현직 컨설턴트들의 개성있는 Case 접근법과 Framework 수록
              </Text>
            </Grid>
            <Grid gap='5px' align='center' marginTop='4px' isNoWrap>
              <Grid image={CheckIcon} width='20px' height='20px' />
              <Text size='1.1rem' bold md={{ size: '0.9rem' }}>
                실제 면접상황에서의 다양한 Delivery 방식과 Communication 노하우까지
              </Text>
            </Grid>
          </Grid>
          <Grid width='50%' md={{ width: '0', height: '0' }}>
            <Grid image={IntroductionImage2} height='240px' md={{ height: '140px' }} />
          </Grid>
        </Grid>
      </Grid>

      <Grid justify='center' marginTop={'50px'} md={{ marginTop: '20px' }}>
        <Grid
          width={`${CWindowWidth}px`}
          padding='0 5%'
          gap='20px'
          isNoWrap
          md={{ padding: '0 7%', isNoWrap: false }}
        >
          <Grid width='50%' md={{ width: '100%' }}>
            <Grid image={IntroductionImage3} height='240px' md={{ height: '140px' }} />
          </Grid>
          <Grid width='50%' md={{ width: '100%' }} align='center'>
            <Grid md={{ justify: 'center' }}>
              <Text size='1.7rem' bold md={{ size: '1.1rem' }}>
                자유롭게 토론하는 “Discussion room”
              </Text>
            </Grid>
            <Grid gap='5px' align='center' marginTop='8px' isNoWrap>
              <Grid image={CheckIcon} width='20px' height='20px' />
              <Text size='1.1rem' bold md={{ size: '0.9rem' }}>
                Case 문제와 다양한 해설에 대해 멘토, 멘티 모두 자유로운 의견 공유
              </Text>
            </Grid>
            <Grid gap='5px' align='center' marginTop='4px' isNoWrap>
              <Grid image={CheckIcon} width='20px' height='20px' />
              <Text size='1.1rem' bold md={{ size: '0.9rem' }}>
                나만의 해설을 올리고 멘토 피드백을 받을 수 있는 공간
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid justify='center' marginTop='80px' md={{ marginTop: '40px' }}>
        <Grid width={`${CWindowWidth}px`} padding='0 5%'>
          {/* <Grid><Text size='2rem' bold>서비스 이용 후기</Text></Grid>
          <Grid isNoWrap gap='20px' marginTop='10px' padding='5px' sm={{ isNoWrap: false }}>
            <Grid sm={{ width: '100%', border: '1px solid #F0F8F6', padding: '5px' }}>
              <Grid><Text size='1.1rem' bold>지원 과정부터 실전 면접까지 모든 요소에 대해 정말 자세하게 알려주십니다.</Text></Grid>
              <Grid style={{ marginTop: 8 }}><Text size='1.1rem' color='#3CAC40'>멘티 K</Text></Grid>
            </Grid>
            <Grid sm={{ width: '100%', border: '1px solid #F0F8F6', padding: '5px' }}>
              <Grid><Text size='1.1rem' bold>지원 과정부터 실전 면접까지 모든 요소에 대해 정말 자세하게 알려주십니다.</Text></Grid>
              <Grid style={{ marginTop: 8 }}><Text size='1.1rem' color='#3CAC40'>멘티 K</Text></Grid>
            </Grid>
          </Grid>
          <Grid isNoWrap gap='20px' padding='5px' marginTop='10px' sm={{ isNoWrap: false }}>
            <Grid sm={{ width: '100%', border: '1px solid #F0F8F6', padding: '5px' }}>
              <Grid><Text size='1.1rem' bold>지원 과정부터 실전 면접까지 모든 요소에 대해 정말 자세하게 알려주십니다.</Text></Grid>
              <Grid style={{ marginTop: 8 }}><Text size='1.1rem' color='#3CAC40'>멘티 K</Text></Grid>
            </Grid>
            <Grid sm={{ width: '100%', border: '1px solid #F0F8F6', padding: '5px' }}>
              <Grid><Text size='1.1rem' bold>지원 과정부터 실전 면접까지 모든 요소에 대해 정말 자세하게 알려주십니다.</Text></Grid>
              <Grid style={{ marginTop: 8 }}><Text size='1.1rem' color='#3CAC40'>멘티 K</Text></Grid>
            </Grid>
          </Grid> */}
          {/* 구매 방법, 생플 보기 추가 */}
          {/* 케이스노트 바로가기 버튼에 로그인여부 로직 추가 */}

          <Grid justify='space-around' margin='100px 0 200px 0' lg={{ gap: '30px' }}>
            <a href={CHowToBuyCaseNote} target='_blank' rel='noopener noreferrer'>
              <Button
                size='large'
                style={{
                  backgroundColor: `${PrimaryColor}33`,
                  height: 86,
                  width: 290,
                  fontSize: '1.8rem',
                }}
              >
                구매 방법
              </Button>
            </a>

            <Button
              size='large'
              style={{
                backgroundColor: `${PrimaryColor}33`,
                height: 86,
                width: 290,
                fontSize: '1.8rem',
              }}
              onClick={() => {
                window.open('/sample.pdf');
                hitCount();
              }}
            >
              샘플 보기
            </Button>
            <Button
              size='large'
              style={{
                backgroundColor: `${PrimaryColor}33`,
                height: 86,
                width: 290,
                fontSize: '1.8rem',
              }}
              onClick={() => {
                history.push('/case/board');
              }}
            >
              케이스 노트 바로 가기
            </Button>

            <Grid>
              <p
                style={{
                  color: `${Colors.grey2}`,
                  marginLeft: '70px',
                  marginTop: '20px',
                }}
              >
                * 이용 가능 기간: 수강권 구매 후 1년
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* <Modal
        visible={showModal}
        onCancel={() => setShowModal(false)}
        title={
          <p style={{ fontSize: '20px', fontWeight: 900, marginTop: '20px' }}>
            로그인 필요
          </p>
        }
        footer={
          <Button type="primary" onClick={() => history.push(`/user/login`)}>
            로그인
          </Button>
        }
      >
        <p style={{ fontSize: '18px' }}>
          케이스 노트 확인을 위해서는 로그인이 필요합니다.
        </p>
      </Modal> */}
    </>
  );
};

export default Introduction;
